import { WithPaginationApiResponseExtended } from './pagination'

export const ContactEntity = {
  COMPANY: 'COMPANY',
  INDIVIDUAL: 'INDIVIDUAL',
} as const

export type ContactEntityType = (typeof ContactEntity)[keyof typeof ContactEntity]

export const RelationshipType = {
  THIRD_PARTY: 'THIRD_PARTY',
  SELF_OWNED: 'SELF_OWNED',
} as const

export type RelationshipType = (typeof RelationshipType)[keyof typeof RelationshipType]

export const InstrumentType = {
  CRYPTO: 'CRYPTO',
  BANK_TRANSFER: 'BANK_TRANSFER',
} as const

export type InstrumentType = (typeof InstrumentType)[keyof typeof InstrumentType]

export interface ContactEntityAddress {
  addressLine1: string
  addressLine2?: string
  city: string
  region: string
  postCode: string
  country: string
}

export interface ContactEntity {
  type: ContactEntityType
  address: ContactEntityAddress
}

export interface ContactEntityIndividual extends ContactEntity {
  firstName: string
  lastName: string
  dateOfBirth: string
}

export interface ContactEntityCompany extends ContactEntity {
  legalName: string
  registrationNumber: string
  dateOfIncorporation: string
}

export interface ContactPayload {
  description: string
  relationshipType: RelationshipType
  entity: ContactEntityIndividual | ContactEntityCompany
}

export interface Contact extends ContactPayload {
  id: string
  name: string
  instruments: ContactInstrument[]
  defaultReference: string
  updatedAt: Date
  createdAt: Date
}

export interface Address {
  addressLine1: string
  addressLine2: string
  city: string
  region: string
  postCode: string
  country: string
}

export interface IntermediaryBank {
  bankName: string
  code: string
  address: Address
}

export interface ContactInstrument {
  id: string
  type: InstrumentType
  description: string
  bankName?: string
  accountNumber?: string
  code?: string
  address: string
  accountType?: string
  accountNumberType?: string
  intermediaryBank?: IntermediaryBank
  network: string
  currency: string
  provider: string
  transferDestination: string
}

export type Contacts = WithPaginationApiResponseExtended<Contact[]>

export interface ContactsRequest {
  size?: number
  page?: number
  searchQuery?: string
}

export interface ContactInstrumentPayload {
  type: InstrumentType
  address: string
  network: string
  currency: string
  description: string
}

export interface ContactInstrumentProps {
  instrumentId?: string
  contactId: string
  instrument?: ContactInstrumentPayload
}

export interface PutContactProps {
  contactId: string
  contact: ContactPayload
}
